import CustomizableDashboard from '../../../components/dashboard/CustomizableDashboard';
import { WIDGET_CATEGORIES } from '../../../components/dashboard/widgetRegistry';
/**
 * CloudOps Dashboard Page
 * Full customizable dashboard with Presets and Customize functionality
 * Help panel is managed at CloudOpsLayout level
 */
const CloudOpsDashboardPage = () => {
  return (
    <CustomizableDashboard
      title="Overview"
      description="Monitor your cloud infrastructure, costs, and compliance"
      storageKey="cloudops-dashboard-layout"
      context="cloudops"
      widgetCategory={WIDGET_CATEGORIES.PLATFORMOPS}
      useBackendPersistence={true}
      allowSetDefault={true}
    />
  );
};

export default CloudOpsDashboardPage;
